import { MessageSquare, PauseCircle, Phone } from "lucide-react";
import { Link } from "react-router-dom";
import { Button } from "./ui/button";
import {
  Dialog,
  DialogContent,
  DialogDescription,
  DialogFooter,
  DialogHeader,
  DialogTitle,
} from "./ui/dialog";
import { INACTIVITY_PHONE } from "../lib/inactivity";

const PHONE_LINK = `tel:${INACTIVITY_PHONE.replace(/\s+/g, "")}`;

/** Banner above the chat while the inactivity block is on (lib/inactivity.ts). */
export function InactivityNotice() {
  return (
    <div className="shrink-0 border-b border-border/20 bg-[#2a0b17] px-4 py-2 text-sm">
      <div className="mx-auto flex max-w-3xl items-start gap-2">
        <PauseCircle className="mt-0.5 h-4 w-4 shrink-0 text-accent" />
        <p className="text-muted-foreground">
          <span className="font-medium text-foreground">Neke funkcije su privremeno nedostupne</span>{" "}
          jer već nekoliko dana nema označenih treninga. Nazovi{" "}
          <a href={PHONE_LINK} className="font-medium text-primary underline-offset-2 hover:underline">
            {INACTIVITY_PHONE}
          </a>{" "}
          ili se javi u{" "}
          <Link to="/chat" className="font-medium text-primary underline-offset-2 hover:underline">
            chatu
          </Link>{" "}
          da ti otvorimo račun.
        </p>
      </div>
    </div>
  );
}

/** The popup a blocked user sees when the app opens or a blocked screen is tapped. */
export function InactivityDialog({
  open,
  onOpenChange,
}: {
  open: boolean;
  onOpenChange: (open: boolean) => void;
}) {
  return (
    <Dialog open={open} onOpenChange={onOpenChange}>
      <DialogContent className="max-w-md">
        <DialogHeader>
          <DialogTitle className="flex items-center gap-2">
            <PauseCircle className="h-5 w-5 text-accent" />
            Neke funkcije su privremeno nedostupne
          </DialogTitle>
          <DialogDescription className="text-left text-base leading-relaxed text-foreground/90">
            Budući da već nekoliko dana nema označenih treninga, dio aplikacije smo privremeno
            zatvorili, kako aplikacija ne bi bez potrebe trošila tvoje podatke. Chat ti je i dalje
            otvoren.
            <br />
            <br />
            Molim te da nazoveš na broj{" "}
            <a href={PHONE_LINK} className="font-semibold text-primary whitespace-nowrap">
              {INACTIVITY_PHONE}
            </a>{" "}
            ili mi pošalješ poruku u chatu da ti otvorimo račun. Hvala ti!
          </DialogDescription>
        </DialogHeader>
        <DialogFooter className="flex-col gap-2 sm:flex-row sm:justify-end">
          <Button asChild variant="outline">
            <a href={PHONE_LINK}>
              <Phone className="mr-2 h-4 w-4" />
              Nazovi
            </a>
          </Button>
          <Button asChild className="bg-accent hover:bg-[#e73e7b]" onClick={() => onOpenChange(false)}>
            <Link to="/chat">
              <MessageSquare className="mr-2 h-4 w-4" />
              Otvori chat
            </Link>
          </Button>
        </DialogFooter>
      </DialogContent>
    </Dialog>
  );
}
